module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modern-upload-field', {
    ref: "uploadField",
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "value": _vm.value,
      "accept": "image/jpeg,image/png,image/webp,image/gif",
      "required": _vm.required,
      "uploading": _vm.uploading,
      "has-error": _vm.fileError || _vm.hasError,
      "error-message": _vm.errorMessage,
      "hint": "Choose race photo (.jpg, .png, .webp)"
    },
    on: {
      "file-selected": _vm.onFileSelect
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "cropImage",
      "clickToClose": false,
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": "600"
    },
    on: {
      "before-open": _vm.resetModalHeight
    }
  }, [_c('div', {
    staticClass: "rup-dialog"
  }, [_c('div', {
    staticClass: "rup-dialog-header"
  }, [_c('span', {
    staticClass: "rup-dialog-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 14a8 8 0 0 1 16 0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 6v12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 10l4-4 4 4"
    }
  })])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "rup-dialog-title"
  }, [_vm._v("Crop Image")]), _vm._v(" "), _c('p', {
    staticClass: "rup-dialog-sub"
  }, [_vm._v("Adjust the race photo before upload")])]), _vm._v(" "), _c('button', {
    staticClass: "rup-close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "rup-dialog-body"
  }, [_c('VueCropper', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedFile),
      expression: "selectedFile"
    }],
    ref: "cropper",
    staticClass: "rup-cropper",
    attrs: {
      "viewMode": 3,
      "zoomable": false,
      "aspect-ratio": 4 / 3,
      "src": _vm.selectedFile,
      "alt": "Source Image"
    }
  }), _vm._v(" "), (_vm.uploading) ? _c('div', {
    staticClass: "rup-progress"
  }, [_c('div', {
    staticClass: "rup-progress-bar"
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "rup-dialog-footer"
  }, [_c('button', {
    staticClass: "rup-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "rup-primary-btn",
    attrs: {
      "type": "button",
      "id": "save-race-image",
      "disabled": _vm.cropSaving
    },
    on: {
      "click": function($event) {
        return _vm.cropImage()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.cropSaving ? 'Saving...' : 'Save') + "\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0373868"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/UploadPhoto.vue
// module id = 1747
// module chunks = 2